const Tipologie = [
    { tipologia: "01", label: "Popolazione e salute", id: "popolazioneSalute" },
    { tipologia: "02", label: "Aree di intervento", id: "areeIntervento" },
    { tipologia: "03", label: "Gestione risorse", id: "gestioneRisorse" },
    { tipologia: "05", label: "Attuazione obiettivi PSSR", id: "attuazioneObbiettivi" }
];

export {
    Tipologie
};